import { useAtomValue } from 'jotai';
import { exportDataAtom } from '@src/components/export/atom';
import buildCsv from '@src/components/export/buildCsv';
import { useMemo } from 'react';

interface ExportConfig {
  page: { key: string; title: string };
  sections: Array<{
    key: string;
    title: string;
    order?: string[];
    selected?: string[];
  }>;
}

export function useOptionsExport({ config }: { config: ExportConfig }) {
  const data: any = useAtomValue(exportDataAtom);

  const filtered = useMemo(() => {
    const res: any = { sections: {} };
    config.sections.forEach((section) => {
      const sectionData = data.sections?.[section.key];
      if (!sectionData) {
        return;
      }

      // Handle dimension tables with selection
      if (section.key === 'overview-dimension-tables' && section.selected !== undefined) {
        res.sections[section.key] = {};
        const widgetKeys = Object.keys(sectionData);
        widgetKeys.forEach((widgetKey) => {
          if (section.selected.includes(widgetKey)) {
            res.sections[section.key][widgetKey] = sectionData[widgetKey];
          }
        });
        return;
      }

      res.sections[section.key] = sectionData;
    });
    return res;
  }, [config.sections, data]);

  const triggerDownload = () => {
    buildCsv({ config, data: filtered });
  };

  return {
    triggerDownload,
  };
}
